import React, { FC } from 'react';
import { FaPen } from 'react-icons/fa';
import { IconProps } from './common/iconProps';

export const PenIcon: FC<IconProps> = ({ className }) => <FaPen className={className} />;
